<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.sistemas"
                        :validations="validations.sistema"
                        label="Sistema"
                        show-default-option
                        v-model="model.sistema_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.versao"
                        label="Versão"
                        v-model="model.versao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.titulo"
                        label="Título"
                        v-model="model.titulo"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-text-editor
                        :validations="validations.descricao"
                        label="Descrição"
                        v-model="model.descricao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-nota-versao-form')
        },
        validations() {
            return {
                sistema: {required: true},
                versao: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                titulo: {
                    required: true,
                    min: 3,
                    max: 200,
                },
                descricao: {required: true},
            }
        },
    },
    data: () => ({
        form: {
            sistemas: [],
        },
        model: {
            versao: null,
            titulo: null,
            descricao: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('cadastro-nota-versao-form')

            if (this.id) {
                this.repositories.cadastro.notaVersao.edit(this.id)
                    .then(({data}) => {
                        this.form = data.form
                        this.model = data.model
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-nota-versao-form'))
            } else {
                this.repositories.cadastro.notaVersao.create()
                    .then(({data}) => {
                        this.form = data.form
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-nota-versao-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-nota-versao-form')

                        const request = {...this.model}

                        if (this.id) {
                            this.repositories.cadastro.notaVersao.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-nota-versao-form'))
                        } else {
                            this.repositories.cadastro.notaVersao.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-nota-versao-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>